import styles from './Gauge.module.scss'

const Gauge = ({
  percentage = 0,
  activeFillColor = '#1B4DFF',
  inactiveFillColor = '#F1DEEA'
}) => {
  const r = 100
  const circumference = 2 * Math.PI * r

  return (
    <div className={styles.svgClipper}>
      <div className={styles.svgHolder}>
        <svg className={styles.gauge}>
          <circle
            className={styles.bgCircle}
            r="100"
            cx="50%"
            cy="50%"
            stroke={inactiveFillColor}
            strokeWidth="16"
            fill="none"
            strokeDasharray={`${circumference / 2}, ${circumference}`}
          ></circle>
          {percentage > 0 && (
            <circle
              className={styles.bgCircle}
              r="100"
              cx="50%"
              cy="50%"
              style={{
                transition: 'all 0.15s ease-in-out'
              }}
              stroke={activeFillColor}
              strokeWidth="16"
              fill="none"
              strokeDasharray={`${(circumference * percentage) / 2}, ${circumference}`}
            ></circle>
          )}
        </svg>
      </div>
      <div className={styles.percentage}>
        {percentage ? Number(percentage * 100).toFixed(2) : 0}%
      </div>
      <div className={styles.minLabel}>0%</div>
      <div className={styles.maxLabel}>100%</div>
    </div>
  )
}

export default Gauge
